import { ReactNode, createContext, useContext } from 'react';
import { RootStore } from './stores/rootStore';

const RootContext = createContext<RootStore | undefined>(undefined);

type Props = {
  children: ReactNode;
};

export const useRootStore = () => {
  const context = useContext(RootContext);
  if (context === undefined) {
    throw new Error('useRootStore must be used within RootContextProvider');
  }
  return context;
};

export const useAccountStore = () => {
  const { accountStore } = useRootStore();
  if (accountStore === undefined) {
    throw new Error('useAccountStore must be used within RootContextProvider');
  }
  return accountStore;
};

export const useAdjustmentStore = () => {
  const { adjustmentStore } = useRootStore();
  if (adjustmentStore === undefined) {
    throw new Error('useAdjustmentStore must be used within RootContextProvider');
  }
  return adjustmentStore;
};

export const useAdvanceStore = () => {
  const { advanceStore } = useRootStore();
  if (advanceStore === undefined) {
    throw new Error('useAdvanceStore must be used within RootContextProvider');
  }
  return advanceStore;
};

export const useAlertStore = () => {
  const { alertStore } = useRootStore();
  if (alertStore === undefined) {
    throw new Error('useAlertStore must be used within RootContextProvider');
  }
  return alertStore;
};

export const useAssetStore = () => {
  const { assetStore } = useRootStore();
  if (assetStore === undefined) {
    throw new Error('useAssetStore must be used within RootContextProvider');
  }
  return assetStore;
};

export const useBulkStore = () => {
  const { bulkStore } = useRootStore();
  if (bulkStore === undefined) {
    throw new Error('useBulkStore must be used within RootContextProvider');
  }
  return bulkStore;
};

export const useCompanyStore = () => {
  const { companyStore } = useRootStore();
  if (companyStore === undefined) {
    throw new Error('useCompanyStore must be used within RootContextProvider');
  }
  return companyStore;
};

export const useDateStore = () => {
  const { dateStore } = useRootStore();
  if (dateStore === undefined) {
    throw new Error('useDateStore must be used within RootContextProvider');
  }
  return dateStore;
};

export const useFilterStore = () => {
  const { filterStore } = useRootStore();
  if (filterStore === undefined) {
    throw new Error('useFilterStore must be used within RootContextProvider');
  }
  return filterStore;
};

export const useHeaderStore = () => {
  const { headerStore } = useRootStore();
  if (headerStore === undefined) {
    throw new Error('useHeaderStore must be used within RootContextProvider');
  }
  return headerStore;
};

export const useHeadlinesStore = () => {
  const { headlinesStore } = useRootStore();
  if (headlinesStore === undefined) {
    throw new Error('useHeadlinesStore must be used within RootContextProvider');
  }
  return headlinesStore;
};

export const useLenderStore = () => {
  const { lenderStore } = useRootStore();
  if (lenderStore === undefined) {
    throw new Error('useLenderStore must be used within RootContextProvider');
  }
  return lenderStore;
};

export const useLoanStore = () => {
  const { loanStore } = useRootStore();
  if (loanStore === undefined) {
    throw new Error('useLoanStore must be used within RootContextProvider');
  }
  return loanStore;
};

export const useMenuStore = () => {
  const { menuStore } = useRootStore();
  if (menuStore === undefined) {
    throw new Error('useMenuStore must be used within RootContextProvider');
  }
  return menuStore;
};

export const useParticipationStore = () => {
  const { participationStore } = useRootStore();
  if (participationStore === undefined) {
    throw new Error('useParticipationStore must be used within RootContextProvider');
  }
  return participationStore;
};

export const usePaymentStore = () => {
  const { paymentStore } = useRootStore();
  if (paymentStore === undefined) {
    throw new Error('usePaymentStore must be used within RootContextProvider');
  }
  return paymentStore;
};

export const useStatementStore = () => {
  const { statementStore } = useRootStore();
  if (statementStore === undefined) {
    throw new Error('useStatementStore must be used within RootContextProvider');
  }
  return statementStore;
};

export const useStatementHeadlinesStore = () => {
  const { statementHeadlinesStore } = useRootStore();
  if (statementHeadlinesStore === undefined) {
    throw new Error('useStatementHeadlinesStore must be used within RootContextProvider');
  }
  return statementHeadlinesStore;
};

export const useLenderStatementHeadlinesStore = () => {
  const { lenderStatementHeadlinesStore } = useRootStore();
  if (lenderStatementHeadlinesStore === undefined) {
    throw new Error('useLenderStatementHeadlinesStore must be used within RootContextProvider');
  }
  return lenderStatementHeadlinesStore;
};

export const useStatementTransactionsStore = () => {
  const { statementTransactionsStore } = useRootStore();
  if (statementTransactionsStore === undefined) {
    throw new Error('useStatementTransactionsStore must be used within RootContextProvider');
  }
  return statementTransactionsStore;
};

export const useLenderStatementTransactionsStore = () => {
  const { lenderStatementTransactionsStore } = useRootStore();
  if (lenderStatementTransactionsStore === undefined) {
    throw new Error('useLenderStatementTransactionsStore must be used within RootContextProvider');
  }
  return lenderStatementTransactionsStore;
};

export const useTransactionStore = () => {
  const { transactionStore } = useRootStore();
  if (transactionStore === undefined) {
    throw new Error('useTransactionStore must be used within RootContextProvider');
  }
  return transactionStore;
};

export const useUserStore = () => {
  const { userStore } = useRootStore();
  if (userStore === undefined) {
    throw new Error('useUserStore must be used within RootContextProvider');
  }
  return userStore;
};

export const RootContextProvider = ({ children }: Props) => {
  const store: RootStore = new RootStore();

  return <RootContext.Provider value={store}>{children}</RootContext.Provider>;
};
